import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';
import '../../constants/criticalResources';

import { createContext } from './createContext';

export function runApp(): void {
  const context = createContext();

  const store = createApplicationState(context);

  renderApplication({ context, store });
}
